import '@/legacy/blocks/blogRegister'
import '@/legacy/blocks/register'

import type { ReactElement } from 'react'

import BlogArticleLayout from '@/legacy/layouts/blog/article'
import { BLOG_ARTICLE_LAYOUT_NAMES } from '@/legacy/layouts/blog/article/constants'
import { MedusaArticleLayout } from '@/legacy/layouts/blog/article/MainLayout/MedusaArticleLayout'
import { ModernArticleLayout } from '@/legacy/layouts/blog/article/MainLayout/ModernArticleLayout'
import type { NextPageWithLayout } from '@/legacy/models/NextPageWithLayout'
import { useBlogArticleCms } from '@/legacy/providers/BlogArticleCmsProvider'

const BlogArticleTemplate: NextPageWithLayout = () => {
  const { getLayout } = BlogArticleTemplate
  const { data } = useBlogArticleCms()

  const layout = data?.layout
  const ContentComponent =
    layout === BLOG_ARTICLE_LAYOUT_NAMES.default ? ModernArticleLayout : MedusaArticleLayout

  if (!getLayout) return <ContentComponent />

  return <>{getLayout(<ContentComponent />)}</>
}

BlogArticleTemplate.getLayout = function getLayout(component: ReactElement) {
  return <BlogArticleLayout>{component}</BlogArticleLayout>
}

export default BlogArticleTemplate
